/**
 * @generated SignedSource<<cae9ed5731c00482212c31f9be9f852a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContactBuyerForm_transaction$data = {
  readonly buyer: {
    readonly mcRedactionOpopAbTest: {
      readonly variant: string | null;
    } | null;
    readonly serviceId: string | null;
  } | null;
  readonly item: {
    readonly serviceId: string | null;
  } | null;
  readonly " $fragmentType": "ContactBuyerForm_transaction";
};
export type ContactBuyerForm_transaction$key = {
  readonly " $data"?: ContactBuyerForm_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContactBuyerForm_transaction">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContactBuyerForm_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "buyer",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": "mcRedactionOpopAbTest",
          "args": [
            {
              "kind": "Literal",
              "name": "testName",
              "value": "MC_removeRedactionOPOP_Mar2026"
            }
          ],
          "concreteType": "AbTestConfigV2UserVariant",
          "kind": "LinkedField",
          "name": "abTestV2",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "variant",
              "storageKey": null
            }
          ],
          "storageKey": "abTestV2(testName:\"MC_removeRedactionOPOP_Mar2026\")"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};
})();

(node as any).hash = "164453561bece3fd430131a10d792159";

export default node;
